import axios from 'axios';

import { buildQueryString } from '../../utils/buildQueryString';

const proposalsBaseURL = `${process.env.REACT_APP_BASE_API_URL}/proposal`;

export const getProposals = async (params?: Record<string, string>) => {
  const { data: currentUser } = await axios.get(`${proposalsBaseURL}/all${buildQueryString(params)}`);

  return currentUser;
};

export const getSingleProposal = async (id: string) => {
  const { data: currentProposal } = await axios.get(`${proposalsBaseURL}/${id}`);

  return currentProposal;
};

export const voteProposal = async (payload: {
  accessToken: string | null | undefined;
  proposalId?: string;
  voteOption: string;
}) => {
  const { accessToken, proposalId, voteOption } = payload;

  const { data: currentProposal } = await axios.put(
    `${proposalsBaseURL}/${proposalId}/vote`,
    { voteOption },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  return currentProposal;
};

export const commentProposal = async (payload: {
  accessToken: string | null | undefined;
  proposalId?: string;
  parentCommentId?: string | '';
  comment: string;
}) => {
  const {
    accessToken,
    proposalId,
    parentCommentId,
    comment
  } = payload;

  const endpoint = parentCommentId
    ? `${proposalsBaseURL}/${proposalId}/comment/${parentCommentId}`
    : `${proposalsBaseURL}/${proposalId}/comment`;

  const { data: currentProposal } = await axios.put(
    endpoint,
    { text: comment },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  return currentProposal;
};
